import { CartUrl} from "../directives/utilities/urls";

export default function studentPendingCoursesList() {
    return {

        studentPendingCoursesList: [],
        showErrorMesage: false,
        studentName: '',
        userName: '',
        showLoader: false,
        courseDeailsUrl: '',
        studentTermsList: [],
        addedCoursesList: [],
        isAccountHoldMessage: false,
        accountHoldMessage:'',
        formatDate(dateValue) {
            const options = { month: 'short', day: 'numeric' };
            const formattedDate = new Date(dateValue).toLocaleDateString(undefined, options);
            return formattedDate;
        },
        //bindStudentTermsList() {

        //    this.studentPendingCoursesList = [];
        //    fetch('/api/StudentAPI/GetStudentSeasons', { "method": "GET" })
        //        .then(response => {
        //            if (response.ok) {
        //                return response.json()
        //            }
        //        }).then(response => {

        //            if (response != undefined && response.isSuccess) {
        //                Array.prototype.push.apply(this.studentTermsList, response.seasons)
        //                if (response.seasons.length > 0) {
        //                    //Get waitlisted courses
        //                    for (let i = 0; i < response.seasons.length; i++) {

        //                        fetch('/api/StudentAPI/GetCourses', {
        //                            method: 'POST',
        //                            headers: {
        //                                'Accept': 'application/json',
        //                                'Content-Type': 'application/json'
        //                            },
        //                            body: JSON.stringify({
        //                                AcademicYear: response.seasons[i].academicYear,
        //                                AcademicTerm: response.seasons[i].academicTerm,
        //                                RequestType: 2,

        //                            })
        //                        }).then(response => {
        //                            return response.json();
        //                        }).then(response => {

        //                            if (response != undefined && response.isSuccess) {
        //                                Array.prototype.push.apply(this.studentPendingCoursesList, response.courses)

        //                            } else {
        //                                this.showErrorMesage = "An unknown error has occurred. Please try again later."
        //                            }

        //                        });
        //                    }
        //                }

        //            } else {
        //                this.showErrorMesage = "An unknown error has occurred. Please try again later."
        //            }

        //        });

        //},
        bindStudentPendingCourses() {

            fetch('/api/StudentAPI/GetPendingCourses', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.studentPendingCoursesList, response.pendingCourses)

                    } else {
                        this.showErrorMesage = "Someting went to wrong."
                    }

                });

        },
        bindClassSchedule(item) {
            return new Promise((resolve, reject) => {
                fetch('/api/StudentAPI/GetScheduleCourses', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        PeopleCodeId: "",
                        RequestType: 1,
                    })
                }).then(response => {
                    return response.json();
                }).then(response => {
                    this.addedCoursesList = response.courses;
                    if (this.addedCoursesList.length > 0) {
                        for (var i = 0; i < this.addedCoursesList.length; i++) {
                            if (this.addedCoursesList[i].academicTerm == item.academicTerm &&
                                this.addedCoursesList[i].serialId == item.serialId &&
                                this.addedCoursesList[i].academicYear == item.academicYear
                            ) {
                                alert('You have already enrolled for this course.');
                                reject('Already enrolled');
                                return;
                            }
                        }
                    }
                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
            });
        },

        addCartList(item) {
            this.bindClassSchedule(item)
                .then(() => {
                    var jsonData = JSON.stringify({
                        "UserSessionId": "",
                        "AcademicYear": item.academicYear,
                        "AcademicTerm": item.academicTerm,
                        "AcademicSession": item.academicSessionId != null ? item.academicSessionId : "UNEX",
                        "SerialId": item.serialId,
                        "CheckoutType": "Course"
                    });
                    this.showLoader = true;

                    fetch("/api/Checkout/add-course-to-cart", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: jsonData,
                    }).then((response) => {
                        return response.json();
                    }).then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.accountHoldMessage = "";
                            window.location.href = CartUrl;
                        } else if (!response.isSuccess && response.checkoutTypeError) {
                            alert(response.message)
                            this.accountHoldMessage = "";
                        } else if (!response.isSuccess && response.message == "Account on hold state.") {
                            this.isAccountHoldMessage = true;
                            this.accountHoldMessage = response.message;
                        }
                        else if (!response.isSuccess && response.message == "Not Logged In") {
                            this.accountHoldMessage = "";
                            window.location.href = CartUrl;
                        }
                    });
                })
                .catch(error => {
                    // Handle errors from bindClassSchedule
                    console.error(error);
                });
        },
        getDetailsUrl(item) {
            const lastWhitespaceIndex = item.eventId.lastIndexOf(" ");

            // Replace the last whitespace with an underscore
            const eventIdWithUnderscore = lastWhitespaceIndex !== -1 ?
                item.eventId.substring(0, lastWhitespaceIndex) + "_" + item.eventId.substring(lastWhitespaceIndex + 1) :
                item.eventId;

            return (
                this.courseDeailsUrl +
                "?eventId=" +
                encodeURIComponent(eventIdWithUnderscore)
            );
        },
        init() {         
            this.bindStudentPendingCourses();
            this.courseDeailsUrl = document.getElementById("courseDeailsUrl").value;

        }
    }
}